import './Profile.scss';
const environment = process.env.REACT_APP_ENV
function Profile()
{
    return(
        <div>
            <h1>User profile</h1>        
            {(environment==='dev') && <a href="https://billing.stripe.com/p/login/test_9B6dR25oFfDK1LrgPq5AQ00">
                Manage Subcription
            </a>}
        </div>
    );    
}

export default Profile;